@if (response.mode === 'alerts' && response.message && showAlert) {
  <nz-alert
    [nzType]="errorType"  
    [nzMessage]="''"
    [nzDescription]="response!.message"
    nzShowIcon
    nzCloseable
    nz-alert
    (nzOnClose)="closeAlert()"
    >
  </nz-alert> 
}

@if(showModal && response.mode === 'modal' && response.message) {
  <nz-modal [(nzVisible)]="showModal" [nzTitle]="titleModal" nzClassName="top-5">
    <ng-container *nzModalContent class="content-modal-overflow">
      <p>
        {{response.message}}
      </p>
  </ng-container>
  <ng-container *nzModalFooter>
    <button nz-button nzType="default" (click)="closeModal()">
      <span>Ok</span>
    </button>
  </ng-container>
  <ng-template #titleModal>
    <h4>
        {{response.title}}
      </h4>
  </ng-template>
  </nz-modal>
}